import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthenticationService } from '../shared/authentication.service';
import { DataService } from '../shared/data.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  model: any = {};
  loading = false;
  noLocalStorage = false;
  returnUrl;
  returnParams: string;
  errors = [];
  customClasses = environment.customClasses;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.authenticationService.logout();
    this.route.queryParams.subscribe((params: Params) => {
      if (params['returnUrl'] && params['returnUrl'].length) {
        let urlParts = params['returnUrl'].split('?');
        this.returnUrl = urlParts[0];
        this.returnParams = urlParts[1];
      }
    });

    try {
      localStorage.setItem('localStorage', '1');
    } catch (e) {
      this.noLocalStorage = true;
      this.errors.push('This website does not support mobile browsers in Private Browsing mode.');
    }
  }

  login() {
    this.loading = true;
    this.errors = [];
    this.authenticationService.login(this.model.email, this.model.password).subscribe(result => {
      if (result === true) {
        this.dataService.changeData({ authenticated: result });
        this.loading = false;
        if (this.returnUrl && this.returnUrl.length && this.returnUrl !== '/logout' && this.returnUrl !== '/') {
          this.router.navigate([this.returnUrl]);
        } else {
          this.router.navigate(['/']);
        }
      } else {
        this.errors.push('Email or password is incorrect');
        this.loading = false;
      }
    }, err => {
      this.loading = false;
      this.errors = err;
    });
  }

  logout() {
    this.loading = true;
    this.authenticationService.logout();
    this.loading = false;
    this.router.navigate(['/login']);
  }

  rememberMe() {
    //
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts